import React, { useEffect } from "react";
import "../styles/AboutSection.css";
import HeroBanner from "./About/HeroBanner";
import PresentationSection from "./About/PresentationSection";
import VisionSection from "./About/VisionSection";
import FounderSection from "./About/FounderSection";
import PartnershipsSection from "./About/PartnershipsSection";
import GovernanceSection from "./About/GovernanceSection";

export default function AboutSection() {
  // Smooth scroll implementation for hash links
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <div className="about-page-container">
      <HeroBanner />
      <div className="about-main-content-wrapper">
        <PresentationSection />
        <VisionSection />
        <FounderSection />
        <PartnershipsSection />
        <GovernanceSection />
      </div>
    </div>
  );
}
